import { SxProps } from '@mui/material'

const container: SxProps = {
  p: 2,
  '& + &': {
    mt: 2,
  },
}

const flexBox: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}

const secondFlexBox: SxProps = {
  ...flexBox,
  mt: 2,
}

const text: SxProps = {
  fontSize: 12,
}

const name: SxProps = {
  fontWeight: 500,
}

const Styles = {
  container,
  flexBox,
  secondFlexBox,
  text,
  name,
}

export default Styles
